import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import ResourceAllocationForm from '../../components/Resources/ResourceAllocationForm';
import './ResourceAllocationCreate.css';

const ResourceAllocationCreate = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/app/resources');
  };

  const handleCancel = () => {
    navigate('/app/resources');
  };

  return (
    <div className="resource-allocation-create-page">
      <div className="page-header">
        <button className="back-button" onClick={() => navigate('/app/resources')}>
          <FiArrowLeft /> Back to Resources
        </button>
        <h1>Create Resource Allocation</h1>
        <p>Assign a team member to a project</p>
      </div>

      <ResourceAllocationForm
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default ResourceAllocationCreate;

